import React from "react";
import { cn } from "@/lib/utils";
import type { VitrineItem, VitrineBadge } from "./data/vitrineItems";

const BADGE_STYLES: Record<VitrineBadge, string> = {
  NOVO: "bg-yellow-400 text-black",
  PREMIUM: "bg-gradient-to-r from-amber-500 to-yellow-500 text-black",
  IA: "bg-gradient-to-r from-fuchsia-500 to-purple-600 text-white",
  GRÁTIS: "bg-emerald-500 text-white",
};

interface VitrineCardProps {
  item: VitrineItem;
  onClick: () => void;
}

const VitrineCard = ({ item, onClick }: VitrineCardProps) => {
  const Icon = item.icon;
  return (
    <button
      onClick={onClick}
      className="group relative flex flex-col text-left rounded-2xl overflow-hidden border border-border bg-card shadow-sm hover:shadow-2xl hover:shadow-yellow-500/20 hover:-translate-y-1 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-yellow-500"
    >
      {/* Cover */}
      <div className={cn("relative aspect-video bg-gradient-to-br overflow-hidden", item.gradient)}>
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        <div className="absolute inset-0 flex items-center justify-center">
          <Icon className="h-16 w-16 text-white/90 drop-shadow-lg group-hover:scale-110 transition-transform" strokeWidth={1.5} />
        </div>
        {/* Badges */}
        <div className="absolute top-2 left-2 flex flex-wrap gap-1">
          {item.badges.map((b) => (
            <span
              key={b}
              className={cn(
                "px-2 py-0.5 rounded-full text-[10px] font-extrabold uppercase tracking-wide shadow",
                BADGE_STYLES[b]
              )}
            >
              {b}
            </span>
          ))}
        </div>
      </div>

      {/* Body */}
      <div className="p-4 flex-1 flex flex-col">
        <h3 className="font-bold text-base text-foreground group-hover:text-yellow-600 transition-colors">
          {item.title}
        </h3>
        <p className="mt-1 text-sm text-muted-foreground line-clamp-2">{item.tagline}</p>
        <div className="mt-3 inline-flex items-center text-xs font-semibold text-yellow-600">
          Ver detalhes →
        </div>
      </div>
    </button>
  );
};

export default VitrineCard;
